import React, { useEffect } from 'react';
import './PopupModal.css'; // use corrected css
import { MdClose } from "react-icons/md";

const PopupModal = ({ isOpen, onClose, title, children }) => {
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div>
                {/* <div className="popup-header">
                    <h2 className="popup-title">{title}</h3>
                    
                </div> */}
                <div className='position-relative'>
                    <div className="popup-close" onClick={onClose}><MdClose /></div>
                    {/* <button className="modal-close" onClick={onClose}><MdClose /></button> */}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default PopupModal;